<div class="mc-spring-board">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    Merge Review Package
    <span class="mc-fill-remaining-flex-space"></span>
    <button mat-icon-button color="secondary-invert" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-body">
    <p class="mc-form-text">Review changes will be applied to your workspace.</p>
    <ul>
      <li>Conflicting changes will be <b>merged</b> automatically.</li>
      <li>A specific <b>save point</b> will be created in your Revision History. You can easily revert if necessary.</li>
      <li>Your files will be in "<b>Editing</b>" mode and <b>no changes will be committed</b> to the repository yet.</li>
    </ul>
  </div>

  <div class="mc-spring-board-footer">
    <button mat-stroked-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button (click)="closeDialog(true)" color="primary">Merge</button>
  </div>
</div>